import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

var store = new Vuex.Store({
  state: {
    isParent: 1,
    userId: -1,
  },
  mutations: {
    setParent (state, tag) {
      state.isParent = tag
    },
    setUserId (state, id) {
      state.userId = id
    }
  },
  getters: {
    optTag (state) {
      return '代理商标记为：' + state.isParent
    },
    optTag (state) {
      return '用户id：' + state.userId
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js